import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UserService} from "../../../../services/user.service";
import {ApiService} from "../../../../services/api.service";
import {PopupService} from "../../../../services/popup.service";

@Component({
  selector: 'app-linkedin',
  templateUrl: './linkedin.component.html',
  styleUrls: ['./linkedin.component.scss']
})
export class LinkedinComponent implements OnInit {

  constructor(
    private routerService: Router,
    private userService: UserService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private popupService: PopupService,
  ) {
  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
          this.processLinkedInAuth(params);
        }
      );
  }

  // Process LinkedIn AUTH
  processLinkedInAuth(params) {
    this.userService.authenticateWithLinkedInToken(params)
      .then(response => {
        // Login successful
        if(response.data.status){
          this.userService.loggedIn = true;
          if(this.userService.checkAuth()){
            this.routerService.navigate(['/dashboard']);
          } else {
            this.routerService.navigate(['/login']);
          }
        } else {
          this.popupService.error("Error", "Failed to login with LinkedIn", "Try again");
          this.userService.loggedIn = false;
          this.routerService.navigate(['/login']);
        }
      }).catch(error => {
        this.popupService.error("Error", "Failed to login with LinkedIn", "Try again");
    })
  }
}
